export default function categoryReducer(state, action) {
  //console.log('STATE  : ', state)
  switch (action.type) {
    case 'GET_ALL_CATEGORIES':
      return {
        ...state,
        categories: action.payload,
        loading: false,
      }
    case 'ADD_CATEGORY':
      return {
        ...state,
        categories: [action.payload, ...state.categories],
      }
    case 'EDIT_CATEGORY':
      const updatedCategory = action.payload

      const updatedCategories = state.categories.map((category) => {
        if (category._id === updatedCategory._id) {
          return updatedCategory
        }
        return category
      })

      return {
        ...state,
        categories: updatedCategories,
      }

    case 'REMOVE_CATEGORY':
      return {
        ...state,
        categories: state.categories.filter((category) => category._id !== action.payload),
      }

    default:
      return state
  }
}
